import cn from "classnames";

export const Blocks = ({ blocks = 1, className }: BlocksProps) => {
  return (
    <span
      data-testid="text-loading-blocks"
      className={cn("flex flex-col gap-2", className)}>
      <span className="flex flex-col gap-3">
        <Block />
        {blocks > 1 ? <Block width="w-5/6" /> : null}
        {blocks > 2 ? <Block width="w-2/5" /> : null}
      </span>
    </span>
  );
};
export type BlocksProps = {
  className?: string;
  blocks?: number;
};

export const Block = ({ height = "h-5", width = "w-full" }: BlockProps) => (
  <span
    data-testid="text-loading-block"
    className={cn("flex animate-pulse bg-gray-300", {
      [width]: width,
      [height]: height,
    })}></span>
);

export type BlockProps = {
  height?: string;
  width?: string;
};
